import React from 'react';
import {RsnButton, RsnDialog} from '~/library/ui-kit';

export function CodeAlreadySent() {
    return (
        <RsnDialog.Window>
            <RsnDialog.CenteredHeader icon={{element: <RsnDialog.StatusIcon status={'attention'} />}}>
                A code has already sent to this number
            </RsnDialog.CenteredHeader>
            <RsnDialog.Body>You will be able to request a new code only at the end of the timer time.</RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Alike as={RsnDialog.CloseTrigger} intent={'primary'}>
                    Continue
                </RsnButton.Alike>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
